module.exports = __webpack_public_path__ + "static/media/ibehavior.c9d86380.svg";